<template>
  <div class="h-full flex items-center justify-center p-4">
    <div class="w-full max-w-sm">
      <div class="flex flex-col justify-center items-center mb-8">
        <svgicon name="logo" class="w-24 h-24 mb-4 text-gray-lightest"/>
        <p class="text-gray-lightest uppercase tracking-wide text-xl font-bold">L'application est vérrouillée</p>
      </div>
      <vue-form class="box w-full max-w-sm" :form="form">
        <form-group field="user_id" label="Sélectionnez un utilisateur">
          <select-user v-model="selected" @select="form.errors.clear()" :config="{ disabled: loading }"/>
        </form-group>
        <form-group field="code" :label="`Entrez votre code ${code}`">
          <number-pad @input="handleInput" :disabled="loading"/>
        </form-group>
      </vue-form>
      <vue-logout>
        <div slot-scope="{logout}" class="flex justify-center mt-8">
          <vue-button class="btn btn-red btn-ghost text-gray-lightest border-gray-lightest rounded-full"
                      icon="close"
                      icon-class="svg-md"
                      @click="logout">Se déconnecter</vue-button>
        </div>
      </vue-logout>
    </div>
  </div>
</template>

<script>
/* globals route */

import Form from 'form-backend-validation';
import SelectUser from '../components/users/UserSelect.vue';
import FormGroup from '../components/FormGroup.vue';
import NumberPad from '../components/NumberPad.vue';
import VueLogout from '../components/auth/Logout.vue';
import ErrorHandler from '../core/ErrorHandler';

export default {
  props: {
    user: {
      required: true,
      type: Object,
    },
  },

  components: { FormGroup, NumberPad, SelectUser, VueLogout },

  data() {
    return {
      selected: this.user,
      loading: false,
      form: new Form({
        user_id: this.user.id,
        code: '',
      }),
    };
  },

  computed: {
    code() {
      return this.form.code.split('').reduce(previous => `${previous}*`, '');
    },
  },

  watch: {
    selected(user) {
      this.form.user_id = user ? user.id : '';
    },
    'form.code': function (value) {
      if (value.length >= 4 && !this.loading) {
        this.submit();
      }
    },
  },

  methods: {
    handleInput(value) {
      this.form.code = `${this.form.code}${value}`;
      this.form.errors.clear();
    },

    submit() {
      this.loading = true;
      this.form
        .post(route('unlock'))
        .then(response => window.location.assign(response.previous_url))
        .catch((error) => {
          new ErrorHandler(error).dispatch();
          this.loading = false;
          this.form.code = '';
        });
    },
  },
};
</script>